var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Analytics\n    "),_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":_vm.refreshData}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("fa-sync")])],1)],1),_vm._v(" "),_c('analytics-data-as-csv'),_vm._v(" "),_c('analytics-filters'),_vm._v(" "),_c('analytics-data')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2846430","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/analytics/AnalyticsOverviewPage.vue
// module id = null
// module chunks = 